import React, { useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Container, Grid } from '@material-ui/core';
import { IoIosMenu, IoIosArrowDropleft } from "react-icons/io";
import { FaHome } from "react-icons/fa";
import { MobileNav } from './MobileNav';
import { FiChevronDown } from 'react-icons/fi';
import { loadMenu } from '../../../../services/menu.service';
import { useDispatch, useSelector } from 'react-redux';
import menu from '../../../../models/menu.model';
import Preloader from '../../../../components/PreLoader';
import { lang } from '../../../../config/app.config';
import { routeFormatter } from '../../../../utils/common.utils';
import translate from '../../../../translation.json';

const MN = new MobileNav('toggle-menu-button', 'ecn-navigation', 'child-menu', 'ecn-dropdown-toggle-icon');


interface state {
  menu: {
    menu: menu,
    loading: boolean
  }
}

const Navbar: React.FC = () => {

  // global state
  const dispatch = useDispatch();
  const state = useSelector((state: state) => {
    const { menu } = state;
    return menu;
  });
  const { loading, menu } = state;
  // end global state

  useEffect(() => {
    MN.init();
  }, [loading]);//eslint-disable-line

  useEffect(() => {
    if (!menu) dispatch(loadMenu('header-menu'));
  }, [dispatch]) // eslint-disable-line

  return (
    <nav className="ech-navbar" id="ecn-navbar">
      <Container maxWidth="lg">
        <Grid container>
          <Grid item xs={6} md={lang == 'np' ? 10 : 11}>
            <ul>
              <li className="navigation-list" id="toggle-menu-button">
                <IoIosMenu />
              </li>
            </ul>
            <div className="menu-backdrop" onClick={() => MN.closeMenu()}></div>
            <ul className="navigation" id="ecn-navigation" style={{ minHeight: '10px', }}>
              <li className="navigation-list close-menu" onClick={() => MN.closeMenu()}>
                <IoIosArrowDropleft /><span>{translate.translation[lang].close_menu}</span>
              </li>
              {
                !loading ?
                  menu && menu.children.length ?

                    menu.children.map((m: any, i) => (
                      <li className="navigation-list" key={i}>
                        <NavLink
                          to={m?.external_url ?
                            { pathname: m?.external_url }
                            :
                            m?.page_exists ? '/' + lang + routeFormatter(m.key) : ''}
                          target={m?.external_url ? '_blank' : '_self'}
                          style={!m?.page_exists ? { pointerEvents: "none" } : {}}
                          exact
                          onClick={() => MN.closeMenu()}
                          activeClassName="active" >
                          <span className="display-flex align-item-center">
                            {m.name ? m.key === '/' ?
                              <FaHome style={{ fontSize: '20px' }} className="menu-home-icon" />
                              : m.name : ""}
                          </span>
                        </NavLink>
                        {m.children && m.children.length ? <FiChevronDown className="ecn-dropdown-toggle-icon" /> : ''}
                        {
                          m.children && m.children.length ?
                            <ul className="child-menu">
                              {
                                m.children.map((child: any, i: number) => (
                                  <li key={i}>
                                    <NavLink to={'/' + lang + routeFormatter(child.key)} exact onClick={() => MN.closeMenu()} activeClassName="active">
                                      <span>{child.name || "/"}</span>
                                    </NavLink>
                                    {child.children && child.children.length ? <FiChevronDown className="child-dropdown" /> : ''}
                                    {
                                      child.children && child.children.length ?
                                        <ul className="sub-menu">
                                          {child.children.map((sub: any, si: number) => (
                                            <li key={si}>
                                              <NavLink to={'/' + lang + routeFormatter(sub.key)} exact onClick={() => MN.closeMenu()} activeClassName="active">
                                                <span>{sub.name || ""}</span>
                                              </NavLink>
                                            </li>
                                          ))}
                                        </ul> :
                                        ""}
                                  </li>
                                ))
                              }

                            </ul> : ''
                        }
                      </li>
                    ))
                    : '' // no menu children

                  : <Preloader />// loading
              }
            </ul>
          </Grid>
          <Grid item xs={6} md={lang == 'np' ? 2 : 1} className="display-flex  align-item-center" style={{ justifyContent: 'flex-end' }}>
            {/* <Link to={`/${lang}/page/voter-list`} className="voter-roll">{translate.translation[lang].voter_roll}</Link> */}
          </Grid>
        </Grid>
      </Container>
    </nav>
  );
}

export default Navbar;